/**
 * The words the check-in columns use, in one place.
 *
 * Three tables show a day's check-ins -- the employee's own history, the team
 * monitor and Attendance Records -- and they have to agree, because the same
 * person reads two of them and asks why the numbers differ.
 *
 * "Passed" is the owner's word for a check-in that was never asked because a
 * meeting or a break was running. The hint exists to stop it being read as a
 * second kind of miss, which is the one way this figure can do harm: it is
 * time nobody expected work in, and it is taken off what the day owed rather
 * than counted against it.
 *
 * Deliberately *not* every skipped check-in. A slot skipped because the shift
 * had ended was still owed by the shift, and labelling that "passed" would
 * show somebody who left at lunch a row full of excuses.
 */

/** The column header. */
export const PASSED_LABEL = 'Passed';

/** The header's tooltip, and the sentence that keeps the column honest. */
export const PASSED_HINT =
  'Check-ins that were never asked because a meeting or a break was running. ' +
  'They come off what the day owed, and are not held against it.';
